import React from 'react';
import { node, bool } from 'prop-types';

export const SlotWrapper = ({ children, sticky = false }) => {
  if (!sticky) return children;
  // Rendered identically on server and client (driven by config, not a
  // post-mount flag) so the sticky section is never reparented/remounted after
  // hydration. Sticky activation is handled purely by the responsive CSS class
  // (active at lg+), matching the previous lg-only sticky behavior.
  return (
    <div className="lg:sui-sticky lg:sui-top-0 lg:sui-z-10">{children}</div>
  );
};

SlotWrapper.propTypes = {
  children: node.isRequired,
  sticky: bool.isRequired,
};